import { defineMessages } from "react-intl";

const messages = defineMessages({
  address: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.address",
    defaultMessage: "Address",
    description: "Merge duplicates - Duplicate Criteria - address",
  },
  cancel: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.cancel",
    defaultMessage: "Cancel",
    description: "Merge duplicates - Duplicate Criteria - cancel button",
  },
  companies: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.company",
    defaultMessage: "Companies",
    description: "Merge duplicates - Duplicate Criteria - company tab",
  },
  confirm: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.confirm",
    defaultMessage:
      "This calculation may take up to several minutes. <b>You won’t be able to update criteria again until this calculation is complete.</b>",
    description: "Merge duplicates - Duplicate Criteria - confirm message",
  },
  confirmCancel: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.confirmCancel",
    defaultMessage: "Go back",
    description: "Merge duplicates - Duplicate Criteria - confirm Cancel button",
  },
  confirmOk: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.confirmOk",
    defaultMessage: "Continue",
    description: "Merge duplicates - Duplicate Criteria - confirm OK button",
  },
  domain: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.domain",
    defaultMessage: "Domain",
    description: "Merge duplicates - Duplicate Criteria - domain",
  },
  email: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.email",
    defaultMessage: "Email",
    description: "Merge duplicates - Duplicate Criteria - email",
  },
  fullUrl: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.fullUrl",
    defaultMessage: "Full URL",
    description: "Merge duplicates - Duplicate Criteria - full URL",
  },
  location: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.location",
    defaultMessage: "Location (exact match)",
    description: "Merge duplicates - Duplicate Criteria - location",
  },
  name: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.name",
    defaultMessage: "Name",
    description: "Merge duplicates - Duplicate Criteria - name",
  },
  nameAlways: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.nameAlways",
    defaultMessage: "Always",
    description: "Merge duplicates - Duplicate Criteria - name always",
  },
  nameInRadius: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.nameInRadius",
    defaultMessage: "Only if within 100m",
    description: "Merge duplicates - Duplicate Criteria - name in radius",
  },
  okText: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.okText",
    defaultMessage: "Save and Re-Calculate",
    description: "Merge duplicates - Duplicate Criteria - OK button",
  },
  people: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.people",
    defaultMessage: "People",
    description: "Merge duplicates - Duplicate Criteria - people tab",
  },
  phone: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.phone",
    defaultMessage: "Phone Number",
    description: "Merge duplicates - Duplicate Criteria - phone",
  },
  recalculatingInProgress: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.recalculatingInProgress",
    defaultMessage: "Ongoing calculation must be completed before criteria can be changed",
    description: "Merge duplicates - Duplicate Criteria - recalculating in progress",
  },
  title: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.title",
    defaultMessage: "Duplicate Criteria",
    description: "Merge duplicates - Duplicate Criteria - modal title",
  },
  website: {
    id: "settings.mergeDuplicates.duplicateCriteriaModal.website",
    defaultMessage: "Website",
    description: "Merge duplicates - Duplicate Criteria - website",
  },
});

export default messages;
